/**
 * Normaliza report-link da API para o modelo da UI (camelCase).
 * @param {Object} item
 * @returns {Object}
 */
export function mapReportLinkApiToView(item) {
  if (!item || typeof item !== "object") {
    return item;
  }

  const isActiveRaw =
    item.is_active !== undefined ? item.is_active : item.isActive;

  const roleRaw =
    item.role && typeof item.role === "object" ? item.role : null;
  const permissionRaw =
    item.permission && typeof item.permission === "object" ? item.permission : null;
  const roleIdRaw = item.role_id ?? item.roleId ?? roleRaw?.id ?? null;
  const permissionKeyRaw =
    item.permission_key ??
    item.permissionKey ??
    permissionRaw?.key ??
    roleRaw?.name ??
    null;
  const permissionIdRaw =
    item.permission_id ??
    item.permissionId ??
    permissionRaw?.id ??
    roleIdRaw ??
    null;

  return {
    id: item.id,
    name: item.name ?? "",
    link: item.link ?? "",
    isActive: isActiveRaw !== undefined ? Boolean(isActiveRaw) : true,
    createdAt: item.created_at ?? item.createdAt ?? null,
    updatedAt: item.updated_at ?? item.updatedAt ?? null,
    permission: permissionRaw,
    role: roleRaw,
    roleId: roleIdRaw,
    permissionKey:
      permissionKeyRaw != null && String(permissionKeyRaw).trim() !== ""
        ? String(permissionKeyRaw).trim()
        : null,
    permissionId:
      permissionIdRaw != null && String(permissionIdRaw).trim() !== ""
        ? permissionIdRaw
        : null,
  };
}
